import React, { useEffect, useState } from 'react';
import { getForms } from '../../actions/formActions';
import ReactModal from 'react-modal';
import { listTrackings, deleteTracking, enableTracking, emptySaveResponse, saveTracking, emptyGetTracking, getTracking, emptyListing } from '../../actions/trackingActions';
import { useSelector, useDispatch } from 'react-redux';
import SearchBoxWithListing from '../Common/SearchBoxWithListing';
import SearchBox from '../Common/SearchBox/SearchBox';
import { FaPlus, FaTimes } from 'react-icons/fa'; // Importing the plus icon
import _ from "lodash"

const ManageTracking = (props) => {
    const searchBoxKey = "tracking_search_form";
    const addBoxKey = "tracking_add_form";
    const editBoxKey = "tracking_edit_form";
    const executeBoxKey = "tracking_execute_form";
    const listFormKey = "tracking_list_form";
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [updatedValues, setUpdatedValues] = useState({});
    const [loadingButton, setLoadingButton] = useState(false);
    const trackingState = useSelector((state) => state.tracking);
    const formState = useSelector((state) => state.forms);
    const [isEdit, setIsEdit] = useState(false);
    const [isExecute, setIsExecute] = useState(false);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const addBoxJson = formJson[addBoxKey] || {};
    const editBoxJson = formJson[editBoxKey] || {};
    const executeBoxJson = formJson[executeBoxKey] || {};
    const { listing = {}, saveResponse = {}, getTrackingResponse = {} } = trackingState;
    const { data = {} } = searchBoxJson;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const addIconField = fields.filter(field => field.id == 'addIcon');
    const showAddIcon = addIconField.length > 0;
    const [{ label = '' } = {}] = addIconField;

    useEffect(() => {
        dispatch(getForms(addBoxKey));
        dispatch(getForms(executeBoxKey));
        dispatch(getForms(editBoxKey));
    }, []);

    const listApi = (data) => {
        return dispatch(listTrackings(data, listFormKey));
    }

    const handleAdd = () => {
        setIsModalOpen(true);
    }

    useEffect(() => {
        if (!_.isEmpty(saveResponse)) {
            const { status = {} } = saveResponse;
            const { success = false } = status;
            if (success) {
                closeModel();
                dispatch(emptyListing());
            }
            dispatch(emptySaveResponse());
            setLoadingButton(false);
        }
    }, [saveResponse]);

    useEffect(() => {
        if (!_.isEmpty(getTrackingResponse)) {
            const { additionalInfo = {}, ...restResponse } = getTrackingResponse;
            const { buyAtEveryDip = [], ...restAdditionalInfo } = additionalInfo;
            const _buyAtEveryDip = buyAtEveryDip.map(dip => ({ dipPercent: dip[0], buyPercent: dip[1] }));
            setUpdatedValues({ tracking: restResponse, additionalInfo: restAdditionalInfo, buyAtEveryDip: _buyAtEveryDip });
        }
    }, [getTrackingResponse]);

    const actionsHandling = (action, rowData) => {
        const { enabled = false, trackingId = '' } = rowData;
        switch (action.id) {
            case "enabled": {
                dispatch(enableTracking({ enabled, trackingId }));
                break;
            }
            case "delete": {
                dispatch(deleteTracking({ trackingId }));
                break;
            }
            case "edit": {
                setIsEdit(true);
                setIsExecute(false);
                setIsModalOpen(true);
                const { trackingId = '' } = rowData;
                dispatch(getTracking(trackingId));
                break;
            }
            case "buy": {
                setUpdatedValues({ trackingId, order: 'BUY' });
                setIsEdit(false);
                setIsExecute(true);
                setIsModalOpen(true);
                break;
            }
            case "sell": {
                const { trackingId = '' } = rowData;
                setUpdatedValues({ trackingId, order: 'SELL' });
                setIsEdit(false);
                setIsExecute(true);
                setIsModalOpen(true);
                break;
            }
            default: alert('Yet to implement');
        }
    }

    const convertDipToPayload = (buyAtEveryDip = []) => {
        return buyAtEveryDip.map(data => {
            const { dipPercent = 0, buyPercent = 0 } = data;
            return [dipPercent, buyPercent];
        })
    }

    const onEdit = (payload) => {
        const { tracking = {}, additionalInfo = {}, buyAtEveryDip = [] } = payload;
        const { trackingId = '', description = '', } = tracking;
        const { targetPercentage = '', stopLossPercentage = '', telegramAlert = false, sellConditions = [] } = additionalInfo;
        const finalPayload = {
            trackingId, description,
            additionalInfo: {
                targetPercentage, stopLossPercentage,
                telegramAlert, sellConditions,
                buyAtEveryDip: convertDipToPayload(buyAtEveryDip)
            }
        };
        dispatch(saveTracking(finalPayload));
    }

    const executeOrder = (payload) => {
        const { price = '', qty = '', order = '', ...restPayload } = payload
        const finalPayload = { ...restPayload, additionalInfo: { price, qty, order } };
        dispatch(saveTracking(finalPayload));
    }

    const onAdd = (payload) => {
        const { tracking = {}, additionalInfo = {}, buyAtEveryDip = [] } = payload;
        const savePayload = {
            ...tracking, additionalInfo: {
                ...additionalInfo,
                buyAtEveryDip: convertDipToPayload(buyAtEveryDip)
            }
        };
        setLoadingButton(true);
        dispatch(saveTracking(savePayload));
    }

    const closeModel = () => {
        setIsModalOpen(false);
        setIsEdit(false);
        setIsExecute(false);
        setUpdatedValues({});
        dispatch(emptyGetTracking());
    }

    const modelJson = isEdit ? editBoxJson : isExecute ? executeBoxJson : addBoxJson;
    const actionHandler = isEdit ? onEdit : isExecute ? executeOrder : onAdd;
    const fetchingJson = isEdit ? _.isEmpty(updatedValues) : isExecute ? _.isEmpty(executeBoxJson) : _.isEmpty(addBoxJson);

    return (
        <div style={{ position: 'relative', paddingBottom: showAddIcon ? '80px' : '0px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={listing}
                actionsHandling={actionsHandling}
            />

            {/* Floating Add Button */}
            {showAddIcon ? <div
                onClick={() => handleAdd()}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'green',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '15px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                }}
                title={label}
            >
                <FaPlus size={20} />
            </div> : ''}
            <ReactModal
                isOpen={isModalOpen}
                onRequestClose={closeModel}
                style={{
                    content: {
                        position: 'relative',
                        inset: 'auto',
                        margin: '0',
                        transform: 'none',
                        width: 'min(900px, 92vw)',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        padding: '20px',
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2000,
                    },
                }}
            >
                {/* Close Icon */}
                {<button
                    onClick={closeModel}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                    }}
                    aria-label="Close"
                >
                    <FaTimes />
                </button>}
                <div>
                    <SearchBox
                        searchBoxJson={modelJson}
                        onSearch={actionHandler}
                        fetchingForm={fetchingJson}
                        fetchingList={loadingButton}
                        updatedValues={updatedValues}
                    />
                    {/* <button
                        className="btn btn-secondary mt-3"
                        onClick={() => setIsModalOpen(false)}
                    >
                        Close
                    </button> */}
                </div>
            </ReactModal>
        </div>
    );
}

export default ManageTracking;
